import axios from '../utils/axios';

export default function addSeekerPlan(adminId, body) {
    return axios.post(`/admin/${adminId}/jobseeker-admin/subscription/admin/create-order?type=regular`, body);
};